module.exports = __webpack_public_path__ + "static/4-24b379c98791d951ee0802f9652e1877.jpg";